export const REMOTE_CONFIG_KEY_IN_LOCALS = 'remoteConfig';

export const RANDOM_NUMBER_COOKIE_KEY = 'ran';
export const PHPSESSID_COOKIE_KEY = 'PHPSESSID';
export const CACHE = 'cache';
export const PRIVE_TIER_KEY = 'PRIVE_TIER';

export const standardMaxAgesForCookies = {
  ONE_DAY: 864000000,
  LONG: 7884000000, // for 3 months
  VERY_LONG: 31536000000, // for 1 year
};
export const GAMES_CONFIG_CACHE_KEY = 'GAMES_CONFIG';
export const GAMES_CONFIG_GET_TIMEOUT = 5000;
export const NB_SKU_CONFIG_CACHE_KEY = 'NB_SKU_CONFIG_CACHE_KEY';
export const NB_SKU_CONFIG_GET_TIMEOUT = 5000;

export const PlatformVsServiceVsEnvMap = {
  nykaa: {
    preprod: 'preprod-pdp',
    smoke: 'smoke-pdp',
    prod: 'prod-pdp',
  },
  men: {
    'preprod-man': 'preprod-man-pdp',
    'smoke-nykaaman': 'smoke-man-pdp',
    'nykaaman-pdp': 'prod-man-pdp',
  },
} as const;

export type Platform = keyof typeof PlatformVsServiceVsEnvMap;
export type DeploymentEnvironment =
  keyof (typeof PlatformVsServiceVsEnvMap)[Platform];
export type ServiceName =
  (typeof PlatformVsServiceVsEnvMap)[Platform][DeploymentEnvironment];

export const getServiceName = (
  platform: Platform,
  env: DeploymentEnvironment
) => PlatformVsServiceVsEnvMap[platform][env];
